module.exports = __webpack_public_path__ + "img/Oiltanking Logística Brasil.dc096e9f.jpg";